export default __webpack_public_path__ + "static/media/abdc.f0355e73.jpg";